import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {CadastrarComponent} from "./pages/cadastrar/cadastrar.component";
import {FinanceiroComponent} from "./pages/financeiro/financeiro.component";
import {AutenticacaoGuard} from "../../../core/guards/autenticacao-guard";
import {MeuPlanoComponent} from "./pages/meu-plano/meu-plano.component";

const routes: Routes = [
  { path: "cadastrar", component: CadastrarComponent },
  { path: "financeiro", component: FinanceiroComponent, canActivate: [AutenticacaoGuard] },
  { path: "meu-plano", component: MeuPlanoComponent, canActivate: [AutenticacaoGuard] },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EmpresaRoutingModule { }
